module.exports = __webpack_public_path__ + "static/media/icon-edit-small.f3a3acc8.svg";